import { combineReducers } from '@reduxjs/toolkit';
import { countriesReducer, CountriesState } from './countries/reducers';
import { healthPlansReducer, HealthPlansState } from './healthPlans/reducers';
import {
  relationshipsToSubscriberReducer,
  RelationshipsToSubscriberState
} from './relationshipsToSubscriber/reducers';
import { configurationReducer, ConfigurationState } from './configuration/reducers';
import { initializationReducer, InitializationState } from './initialization/reducers';

export type SystemState = {
  countries: CountriesState;
  healthPlans: HealthPlansState;
  relationshipsToSubscriber: RelationshipsToSubscriberState;
  configuration: ConfigurationState;
  initialization: InitializationState;
};

export const systemReducer = combineReducers({
  countries: countriesReducer,
  healthPlans: healthPlansReducer,
  relationshipsToSubscriber: relationshipsToSubscriberReducer,
  configuration: configurationReducer,
  initialization: initializationReducer
});
